import {formatCurrencyValue} from "../../../../util/PaymentUtils";
import {formatDateMMDDYYYY} from "../../../../util/DateUtils";
import type {FilterInputProps, SelectInputProps} from "../../../../components/SortFilter/interfaces";

/** The booked-location fields (from the API's LocationBookingSearchViewVO) that formatBookedLocations formats. */
interface BookedLocation {
  address: string;
  // A java.util.Date, which the API's ObjectMapper serializes as epoch milliseconds.
  lastBooked: number;
  pricePerDay: number;
  pricePerMonth: number;
}

type FormattedBookedLocation<T extends BookedLocation> = Omit<T, 'lastBooked' | 'pricePerDay' | 'pricePerMonth'> & {
  addressLine1: string;
  lastBooked: string;
  pricePerDay: string | number;
  pricePerMonth: string | number;
};

export const filterByOptions: FilterInputProps[] = [
  { name: "city", label: "City"},
  { name: "state", label: "State"}
];

export const sortByFields: SelectInputProps[] = [
  { label: "Supplier", value: "SUPPLIER"},
  { label: "Last Booked Date", value: "LAST_BOOKED"},
  { label: "Daily Price", value: "PRICE_PER_DAY"},
  {label: "Monthly Price", value: "PRICE_PER_MONTH"},
];

export const headCells: { id: string, label: string }[] = [
  {id: "supplier", label: "Supplier Name"},
  {id: "features", label: "Features"},
  {id: "equipmentTypes", label: "Equipment Types"},
  {id: "pricePerMonth", label: "Monthly Rate"},
  {id: "pricePerDay", label: "Daily Rate"},
  {id: "lastBooked", label: "Last Booked Date"},
  {id: "totalBookings", label: "Total Bookings"},
];

export const formatBookedLocations = <T extends BookedLocation>(locations: T[]): FormattedBookedLocation<T>[] => {
  return locations.map(location => ({
    ...location,
    pricePerMonth: formatCurrencyValue(location.pricePerMonth),
    pricePerDay: formatCurrencyValue(location.pricePerDay),
    lastBooked: formatDateMMDDYYYY(location.lastBooked),
    addressLine1: location.address,
  }));
};
